import React from "react"
import Location from "./location"
export default function LocationContainer() {
    return (
        <Location>
            <Location.Map />
        </Location>
    )
}


